import { type DashRouteType, URL_APP_ADMIN } from '@retailer-platform/dashboard/route-patterns'

const URL_APPROVALS_MANAGEMENT = `${URL_APP_ADMIN}/approvals-management`
export const URL_AML_MCP_MUTATION_APPROVAL_REQUEST = `${URL_APPROVALS_MANAGEMENT}/mcp-mutation-approval-request/:approvalRequestId`

export type McpMutationsDashRouteSet =
  DashRouteType<'app-admin-approvals-management-library-mcp-mutation-approval-request'>

export const mcpMutationsRoutes: { [Key in McpMutationsDashRouteSet['identifier']]: string } = {
  'app-admin-approvals-management-library-mcp-mutation-approval-request':
    URL_AML_MCP_MUTATION_APPROVAL_REQUEST,
}

export type McpMutationsDomainRouteName = keyof typeof mcpMutationsRoutes
